import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';

import { BasicosComponent } from './Basicos.component';


import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';



const routes = [
    {
        path     : 'Basicos',
        component: BasicosComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Basicos',
          nombreFormulario : 'Basicos'
        } 
    }
];

@NgModule({
    declarations: [
        BasicosComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        BasicosComponent
    ]
})

export class BasicosModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Basicos/Basicos.module.ts